import { render, staticRenderFns } from "./city-form-page.vue?vue&type=template&id=dfba9064&scoped=true&"
import script from "./city-form-page.vue?vue&type=script&lang=js&"
export * from "./city-form-page.vue?vue&type=script&lang=js&"
import style0 from "./city-form-page.vue?vue&type=style&index=0&id=dfba9064&lang=scss&scoped=true&"
import style1 from "./city-form-page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfba9064",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QForm,QInput,QBtn,QSpinnerIos,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QForm,QInput,QBtn,QSpinnerIos,QField})
